import {FC} from 'react';

type StaticFieldProps = {
  label: string,
  value: string
}

const StaticField: FC<StaticFieldProps> = ({label, value}) => (
  <div className="static-field">
    <p className="static-field__label">{label || ''}</p>
    <p className="static-field__value">{value || ''}</p>
  </div>
);

export default StaticField;
